export class DeviceStatisticRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'DeviceStatistic';
        const model = App.Models.DeviceStatistic;
        const collectionClass = App.Collections.DeviceStatistics;

        super(entityName, model, collectionClass);
    }

    beforeList = () => {
        const grid = App.Forms.DeviceStatistic.table;
        const menu = new Greenmile.DeviceStatistic.Grid.Menu();
        const toShowMenu = function (menu) {
            return function (e, args) {
                menu.showMenuToRowSelected(e, args);
            };
        }(menu);

        menu.setEnabledMenus(Monet.Grid.Utils.getMenusEnabledFromGridLayout(App.Forms[this.entityName].layout.index));

        grid.onClick.unsubscribe(toShowMenu);
        grid.onClick.subscribe(toShowMenu);

        if (!grid.getSortColumns().length && grid.getColumnByFieldName('when')) {
            App.Forms.DeviceStatistic.columnToOrders = [{ field: "when", order: "ASC" }];
            grid.setSortColumns([{ columnId: grid.getColumnByFieldName('when').id, sortAsc: false }]);
        }

        App.Forms.DeviceStatistic.filterBuilder.callbackBeforeFilter = () => {
            const filterBuilder = App.Forms.DeviceStatistic?.filterBuilder;
            const projection = JSON.parse(filterBuilder.projection);
            projection.filters.push('route.id');
            filterBuilder.projection = JSON.stringify(projection);

            this.changeBehaviorOfMessageFieldFilter();
        };
    }

    changeBehaviorOfMessageFieldFilter() {
        const fields = App.Forms.DeviceStatistic?.fields;
        const filterBuilder = App.Forms.DeviceStatistic?.filterBuilder;
        const fieldList = filterBuilder?.fieldList;
        const fieldDomains = [
            { value: 'DeviceStatistic.airplanModeChanged', description: 'DeviceStatistic.airplanModeChanged' },
            { value: 'DeviceStatistic.bootCompleted', description: 'DeviceStatistic.bootCompleted' },
            { value: 'DeviceStatistic.reboot', description: 'DeviceStatistic.reboot' },
            { value: 'DeviceStatistic.shutdown', description: 'DeviceStatistic.shutdown' },
            { value: 'DeviceStatistic.connectivtyChange', description: 'DeviceStatistic.connectivtyChange' },
            { value: 'DeviceStatistic.gpsChanged', description: 'DeviceStatistic.gpsChanged' },
            { value: 'DeviceStatistic.periodicLogger', description: 'DeviceStatistic.periodicLogger' },
            { value: 'DeviceStatistic.deviceWithoutGoogleServices', description: 'DeviceStatistic.deviceWithoutGoogleServices' },
            { value: 'DeviceStatistic.timeChanged', description: 'DeviceStatistic.timeChanged' },
            { value: 'DeviceStatistic.appWillResignActive', description: 'DeviceStatistic.appWillResignActive' },
            { value: 'DeviceStatistic.appDidEnterBackground', description: 'DeviceStatistic.appDidEnterBackground' },
            { value: 'DeviceStatistic.appWillEnterForeground', description: 'DeviceStatistic.appWillEnterForeground' },
            { value: 'DeviceStatistic.appDidBecomeActive', description: 'DeviceStatistic.appDidBecomeActive' },
            { value: 'DeviceStatistic.appWillTerminate', description: 'DeviceStatistic.appWillTerminate' },
            { value: 'DeviceStatistic.bluetoothOn', description: 'DeviceStatistic.bluetoothOn' },
            { value: 'DeviceStatistic.bluetoothOff', description: 'DeviceStatistic.bluetoothOff' },
            { value: 'DeviceStatistic.sendingGPS', description: 'DeviceStatistic.sendingGPS' },
        ];
        const messageField = fields?.message || fieldList?.message || {};
        const messageFieldToPickList = {
            ...messageField,
            type: "PICKLIST",
            fieldDomains
        };

        const valueToFilter = this.getResourceValueFromFieldDomains(filterBuilder, fieldDomains);

        if (fieldList && fieldList?.message?.type === "TEXT") {
            this.handleToChangeTheMessageFieldBehavior(messageFieldToPickList, filterBuilder, valueToFilter);
        }

        this.handleToProvideCriteriaToMessageFieldFilter(filterBuilder, valueToFilter);
    }

    handleToProvideCriteriaToMessageFieldFilter(filterBuilder, valueToFilter) {
        filterBuilder.criteriaChain.criteriaChain[0].and =
            filterBuilder.criteriaChain.criteriaChain[0].and.map((criteria) => {
                if (criteria.attr === "message") {
                    return {
                        ...criteria,
                        eq: valueToFilter?.value || '',
                        matchMode: "EXACT"
                    };
                }

                return criteria;
            });
    }

    handleToChangeTheMessageFieldBehavior(messageFieldToPickList, filterBuilder, valueToFilter) {
        const haveFieldAlreadyRendered = filterBuilder?.fields?.message;
        const overrideTheFieldTypeTextToPickList = () => {
            App.Forms.DeviceStatistic.fields.message = messageFieldToPickList;
            App.Forms.DeviceStatistic.dataMapper.message = messageFieldToPickList;
            App.Forms.DeviceStatistic.filterBuilder.fieldList.message = messageFieldToPickList;
        };
        const renderFieldWithPickListType = () => {
            App.Forms.DeviceStatistic.filterBuilder.addSelectedFilter(
                App.Forms.DeviceStatistic.filterBuilder,
                App.Forms.DeviceStatistic.filterBuilder.fieldList.message,
                valueToFilter?.value || ''
            );
        };
        const removeFieldRenderedWithTextType = () => {
            filterBuilder.fields.message.rootEl.parentElement.remove();
            filterBuilder.fields.message = null;
        };

        overrideTheFieldTypeTextToPickList();

        if (haveFieldAlreadyRendered) {
            removeFieldRenderedWithTextType();
            renderFieldWithPickListType();
        }
    }

    getResourceValueFromFieldDomains(filterBuilder, fieldDomains) {
        const resourceKeyThatMatchCriteria = (criteria) => (fieldDomain) => {
            const fromTranslate = criteria.eq === Monet.I18n.getResourcesByKey(fieldDomain.value);

            return fromTranslate || criteria.eq === fieldDomain.value;
        };
        const criteriaChainToValueToFilter = (valueResult, criteria) => {

            if (criteria.attr === "message") {
                const resourceFromFieldDomain = fieldDomains.find(resourceKeyThatMatchCriteria(criteria));

                return {
                    value: resourceFromFieldDomain?.value,
                };
            }

            return valueResult;
        };

        return filterBuilder.criteriaChain.criteriaChain[0].and.reduce(criteriaChainToValueToFilter, {});
    }
}

App.Routers.DeviceStatistic = DeviceStatisticRouter;